import { Popover } from '@base-ui-components/react/popover';
import StatBlock from "./StatBlock";
import { getImageUrl } from '../../constants';


export const CreaturePopup = ({ creature, handleSelectCreature }) => {
    let currentEncounter = {
        encounterName: "DmBuddyCreaturePopup", 
        creatures: [creature]
    }
    
    const setCurrentEncounter = () => {console.log("popup setCurrentEncounter")}
    const closeStatBlock = () => {console.log("popup closeStatBlock")}
    const handleUploadMonsterImage = () => {console.log("popup handleUploadMonsterImage")}

    const popAdd = (action) => {
        if (creature.avatarUrl === null) {
            getImageUrl(creature.name, creature.creature_type).then((url) => {
                creature.avatarUrl = url;
                handleSelectCreature(creature, action)
            })
        } else {
            handleSelectCreature(creature, action)
        }
        
    } 

    return <Popover.Root openOnHover={true} delay={500}>
                
                <Popover.Trigger className='triggerButton'><b>{creature.name.split('|')[0]}</b></Popover.Trigger> 
                <button title={`Add '${creature.name}' to Encounter`} className='monsterPopUpAdd' onClick={() => popAdd("add")}>
                    ➕
                </button>
                <button title={`Pin '${creature.name}' Statblock`} className='monsterPopUpAdd' onClick={() => popAdd("select")}>
                    📝
                </button>
                <Popover.Portal>
                    <Popover.Positioner align={'end'} sticky={true}>
                        <Popover.Popup className='hoverPopup'>
                            <Popover.Description key={creature.name} style={{all: 'unset'}} render={<div />}>
                                <div className='statContainers' style={{flex: "1 1 0%", padding: "2px"}}>
                                    <div className='column' style={{width: "100%", height: "unset"}}>
                                        <StatBlock selectedIndex={0} 
                                            currentEncounter={currentEncounter}
                                            setCurrentEncounter={setCurrentEncounter}
                                            closeStatBlock={closeStatBlock}
                                            handleUploadMonsterImage={handleUploadMonsterImage}
                                        />
                                    </div>
                                </div>
                            </Popover.Description>
                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>;
}
